import script from "./eventsView.vue?vue&type=script&setup=true&lang=js"
export * from "./eventsView.vue?vue&type=script&setup=true&lang=js"

import "./eventsView.vue?vue&type=style&index=0&id=bb36627c&lang=scss&scoped=true"
import "./eventsView.vue?vue&type=style&index=1&id=bb36627c&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb36627c"]])

export default __exports__